import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "read-results" }
const _hoisted_2 = { class: "summary" }
const _hoisted_3 = {
  key: 0,
  class: "error-table"
}
const _hoisted_4 = {
  key: 1,
  class: "error-table"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h3", null, "検証結果", -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _cache[0] || (_cache[0] = _createTextVNode(" 項目数: ", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.totalItems), 1)
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["error-count", { 'has-errors': _ctx.errorCount }])
      }, [
        _cache[1] || (_cache[1] = _createTextVNode(" エラー数: ", -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.errorCount), 1)
      ], 2)
    ]),
    (_ctx.isFreeTextError)
      ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "ページ"),
              _createElementVNode("th", null, "表示順(@)"),
              _createElementVNode("th", null, "項目名"),
              _createElementVNode("th", null, "PDFリネーム(#)"),
              _createElementVNode("th", null, "型(=)"),
              _createElementVNode("th", null, "エンジン(*)"),
              _createElementVNode("th", null, "エラー")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations.filter((a) => a.contents?.trim() !== ''), ({ contents, fieldName, page, displayOrder, itemName, pdfName, fieldType, engineName  }, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass(_ctx.getRowClass(contents, page, fieldName))
              }, [
                _createElementVNode("td", null, _toDisplayString(page), 1),
                _createElementVNode("td", null, _toDisplayString(displayOrder), 1),
                _createElementVNode("td", null, _toDisplayString(itemName || fieldName), 1),
                _createElementVNode("td", null, _toDisplayString(pdfName), 1),
                _createElementVNode("td", null, _toDisplayString(fieldType), 1),
                _createElementVNode("td", null, _toDisplayString(engineName), 1),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors.filter((err) => (err.annotation === contents) && err.page === page), (error, errIndex) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: 'error-cell-' + index + '-' + errIndex,
                      class: _normalizeClass(error.level === 'error' ? 'error-message' : 'warning-message')
                    }, _toDisplayString(error.message), 3))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ])
        ]))
      : (_openBlock(), _createElementBlock("table", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "ページ"),
              _createElementVNode("th", null, "項目名"),
              _createElementVNode("th", null, "型(=)"),
              _createElementVNode("th", null, "エラー")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.annotations, ({ contents, fieldName, page, fieldType, checkBox, combo, radioButton  }, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass(_ctx.getRowClass(contents, page, fieldName))
              }, [
                _createElementVNode("td", null, _toDisplayString(page), 1),
                _createElementVNode("td", null, _toDisplayString(fieldName), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getFieldDisplayType(fieldType,checkBox,combo,radioButton)), 1),
                _createElementVNode("td", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors.filter((err) => (err.annotation === contents || err.annotation === fieldName) && err.page === page), (error, errIndex) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: 'error-cell-' + index + '-' + errIndex,
                      class: _normalizeClass(error.level === 'error' ? 'error-message' : 'warning-message')
                    }, _toDisplayString(error.message), 3))
                  }), 128))
                ])
              ], 2))
            }), 128))
          ])
        ]))
  ]))
}